const lang = {
  AA: 'アファル語',
  AB: 'アブハジア語',
  AF: 'アフリカーンス語',
  AK: 'アカン語',
  AM: 'アムハラ語',
  AR: 'アラビア語',
  AN: 'アラゴン語',
  AS: 'アッサム語',
  AV: 'アヴァル語',
  AE: 'アヴェスタ語',
  AY: 'アイマラ語',
  AZ: 'アゼルバイジャン語',
  BA: 'バシキール語',
  BM: 'バンバラ語',
  BE: '白ロシア語',
  BN: 'Bengali',
  BH: 'ビハール語族',
  BI: 'ビスラマ語',
  BO: 'チベット語',
  BS: 'ボスニア語',
  BR: 'ブルトン語',
  BG: 'ブルガリア語',
  CA: 'カタロニア語; バレンシア語',
  CS: 'チェコ語',
  CH: 'チャモロ語',
  CE: 'チェチェン語',
  CU: '教会スラブ語; 古スラブ語; 教会スラブ語; 古ブルガリア語; 古教会スラブ語',
  CV: 'チュヴァシュ語',
  KW: 'コーンウォール語',
  CO: 'コルシカ語',
  CR: 'クリー語',
  CY: 'ウェールズ語',
  DA: 'デンマーク語',
  DE: 'ドイツ語',
  DV: 'ディベヒ語; ディヴェーヒー語; モルジブ語',
  DZ: 'ゾンカ語',
  EL: 'ギリシア語, 現代 (1453-)',
  EN: '英語',
  EO: 'エスペラント語',
  ET: 'エストニア語',
  EU: 'バスク語',
  EE: 'エウェ語',
  FO: 'フェロー語',
  FA: 'ペルシア語',
  FJ: 'フィジー語',
  FI: 'フィン語',
  FR: 'フランス語',
  FY: '西フリジア語',
  FF: 'フラ語',
  GD: 'ゲール語; スコットランド・ゲール語',
  GA: 'アイルランド語',
  GL: 'ガリシア語',
  GV: 'マン島語',
  GN: 'グアラニー',
  GU: 'グジャラーティー語',
  HT: 'ハイチ; ハイチ混成語',
  HA: 'ハウサ語',
  HE: 'ヘブライ語',
  HZ: 'ヘレロ語',
  HI: 'ヒンディー語',
  HO: 'ヒリモトゥ語',
  HR: 'クロアチア語',
  HU: 'ハンガリー語',
  HY: 'アルメニア語',
  IG: 'イボ語',
  IO: 'イド語',
  II: 'Sichuan Yi; Nuosu',
  IU: 'イヌクウティトット語',
  IE: 'Interlingue; Occidental',
  IA: 'インターリングア語 (国際補助語協会)',
  ID: 'インドネシア語',
  IK: 'イヌピアック語',
  IS: 'アイスランド語',
  IT: 'イタリア語',
  JV: 'ジャワ語',
  JA: '日本語',
  KL: 'カラアリス語; グリーンランド語',
  KN: 'カンナダ語',
  KS: 'カシミーリー語',
  KA: 'グルジア語',
  KR: 'カヌリ語',
  KK: 'カザーフ語',
  KM: '中央クメール語',
  KI: 'キクユ語; Gikuyu',
  RW: 'キンヤルワンダ語',
  KY: 'キルギス語; クルグズ語',
  KV: 'コミ語',
  KG: 'コンゴ語',
  KO: '朝鮮語',
  KJ: 'クアニャマ語; Kwanyama',
  KU: 'クルド語',
  LO: 'ラオ語',
  LA: 'ラテン語',
  LV: 'ラトヴィア語',
  LI: 'リンブルフ語',
  LN: 'リンガラ語',
  LT: 'リトアニア語',
  LB: 'ルクセンブルク語; レッツェブルク語',
  LU: 'ルバ語',
  LG: 'ガンダ語',
  MH: 'マーシャル語',
  ML: 'マラヤーラム語',
  MR: 'マラーティー語',
  MK: 'マケドニア語',
  MG: 'マラガシ語',
  MT: 'マルタ語',
  MN: '蒙古語',
  MI: 'マオリ語',
  MS: 'マライ語',
  MY: 'ビルマ語',
  NA: 'ナウル語',
  NV: 'ナヴァホ語',
  NR: 'マタベレ語, 南; 南ヌデベレ語',
  ND: 'マタベレ語, 北; 北ヌデベレ語',
  NG: 'ンドンガ語',
  NE: 'ネパール語',
  NL: 'オランダ語; フラマン語',
  NN: 'ニーノシュク・ノルウェー語; ノルウェー語, ニーノシュク',
  NB: 'Bokmål, Norwegian; Norwegian Bokmål',
  NO: 'ノルウェー語',
  NY: 'チチェワ語; チェワ語; ニャンジャ語',
  OC: 'Occitan (post 1500); Provençal',
  OJ: 'オジブワ語',
  OR: 'オリヤー語',
  OM: 'オロモ語',
  OS: 'オセト語; オセット語',
  PA: 'パンジャブ語; Punjabi',
  PI: 'パーリ語',
  PL: 'ポーランド語',
  PT: 'ポルトガル語',
  PS: 'Pushto; Pashto',
  QU: 'キチュワ語',
  RM: 'ロマンシュ語',
  RO: 'Romanian; Moldavian; Moldovan',
  RN: 'ルンディ語',
  RU: 'ロシア語',
  SG: 'サンゴ語',
  SA: '梵語',
  SI: 'シンハラ語; シンハリーズ語',
  SK: 'スロヴァキア語',
  SL: 'スロヴェニア語',
  SE: '北サーミ語',
  SM: 'サモア語',
  SN: 'ショナ語',
  SD: 'シンディー語',
  SO: 'ソマリ語',
  ST: 'ソト語, 南',
  ES: 'スペイン語; Castilian',
  SQ: 'アルバニア語',
  SC: 'サルデーニャ語',
  SR: 'セルビア語',
  SS: 'シスワティ語',
  SU: 'スンダ語',
  SW: 'スワヒリ語',
  SV: 'スウェーデン語',
  TY: 'タヒチ語',
  TA: 'タミル語',
  TT: 'タタール語',
  TE: 'テルグ語',
  TG: 'タジク語',
  TL: 'タガログ語',
  TH: 'タイ語',
  TI: 'ティグリニア語',
  TO: 'トンガ語 (トンガ諸島)',
  TN: 'ツワナ語',
  TS: 'ツォンガ語',
  TK: 'トゥルクメン語',
  TR: 'トルコ語',
  TW: 'トウィ語',
  UG: 'ウイグル語; Uyghur',
  UK: 'ウクライナ語',
  UR: 'ウルドゥー語',
  UZ: 'ウズベク語',
  VE: 'ベンダ語',
  VI: 'ベトナム語',
  VO: 'ボラピューク語',
  WA: 'ワロン語',
  WO: 'ウォロフ語',
  XH: 'ホサ語',
  YI: 'イディッシュ語',
  YO: 'ヨルバ語',
  ZA: 'チュワン語; チワン語',
  ZH: '中国語',
  ZU: 'ズールー語'
};

export default lang;
